import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DayCloseSummary } from "../../../domain/repos/day-close-repo";
import { type DayCloseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface SubmitDayCloseParams {
  businessDate: string;
  deliveredRequestIds: string[];
  returnedRequestIds: string[];
  lat: number;
  long: number;
}

/** Closes the ambassador's day: reconciles delivered (consigned portfolios) +
 *  returned (cards to the pool) with the geo-stamp. */
export const submitDayClose = createAsyncThunk<
  DayCloseSummary,
  SubmitDayCloseParams,
  { dispatch: DayCloseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.SUBMIT_DAY_CLOSE, async (params, { extra }) => {
  return extra.dayCloseRepo.close(params);
});
